

// import React, { useEffect, useState } from "react";
// import { Box } from "@mui/material";

// const SegmentedBar = ({ score }) => {
//   const totalSegments = 20;

//   // Smooth fill animation
//   const [progress, setProgress] = useState(0);
//   useEffect(() => {
//     let start = 0;
//     const animate = () => {
//       start += 2; // animation speed
//       setProgress(Math.min(start, score));
//       if (start < score) requestAnimationFrame(animate);
//     };
//     requestAnimationFrame(animate);
//   }, [score]);

//   // 🎨 Determine color palette by range
//   let fillColor = "#C71313", bgColor = "#F5C3C3";
//   if (score > 25 && score <= 50) {
//     fillColor = "#FBBC05"; bgColor = "#FEF0C6";
//   } else if (score > 50 && score <= 75) {
//     fillColor = "#0F62FE"; bgColor = "#9DB8FF";
//   } else if (score > 75) {
//     fillColor = "#008200"; bgColor = "#79DC79";
//   }

//   const filledSegments = Math.round((progress / 100) * totalSegments);

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         width: { xs: "100%", sm: "18rem", md: "16.375rem" },
//         height: { xs: "1rem", sm: "1.15rem", md: "1.25rem" },
//         border: "1px solid #C0C7CF",
//         borderRadius: "0.5rem",
//         overflow: "hidden",
//         backgroundColor: bgColor,
//       }}
//     >
//       {[...Array(totalSegments)].map((_, i) => (
//         <Box
//           key={i}
//           sx={{
//             flex: 1,
//             backgroundColor: i < filledSegments ? fillColor : "transparent",
//             borderRight:
//               i !== totalSegments - 1 ? "1px solid rgba(0,0,0,0.05)" : "none",
//             transition: "background-color 0.3s ease",
//           }}
//         />
//       ))}
//     </Box>
//   );
// };

// export default SegmentedBar;

import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
const unfilledColor = "#F5F6F8";

const SegmentedBar = ({ score }) => {
  const totalSegments = 20;

  // Smooth fill animation
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    let start = 0;
    const animate = () => {
      start += 2;
      setProgress(Math.min(start, score));
      if (start < score) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, [score]);


  let fillColor = "#C71313", bgColor = "#F5C3C3"; // INITIAL default
 
  
  if (score > 50 && score <= 75) {
   
    fillColor = "#FBBC05"; 
    bgColor = "#FEF0C6";
  
  } else if (score > 75 && score <= 90) {
 
    
    fillColor = "#008200"; 
    bgColor = "#79DC79";
  
  } else if (score > 90) {
    
    fillColor = "#0F62FE"; 
    bgColor = "#9DB8FF";
  }
  

  const filledSegments = Math.round((progress / 100) * totalSegments);

  return (
    <Box
      sx={{
        display: "flex",
        width: { xs: "100%", sm: "18rem", md: "16.375rem" },
        height: { xs: "1rem", sm: "1.15rem", md: "1.25rem" },
        //border: "1px solid #C0C7CF",
       // borderRadius: "0.5rem",
        overflow: "hidden",
        backgroundColor: unfilledColor,

      }}
    >
      {[...Array(totalSegments)].map((_, i) => (
        <Box
          key={i}
          sx={{
            flex: 1,
            backgroundColor: i < filledSegments ? fillColor : unfilledColor,

            transition: "background-color 0.4s ease",
            // Remove visible borders for smooth bar look
            borderRight:
              i !== totalSegments - 1 ? "1px solid rgba(255,255,255,0.4)" : "none",
          }}
        />
      ))}
    </Box>
  );
};

export default SegmentedBar;
